import dayjs, { type Dayjs } from 'dayjs';

export function apiTaxDateToDayjs(value: unknown): Dayjs | null {
  if (value == null || value === '') return null;
  if (typeof value !== 'string') return null;
  const d = dayjs(value);
  return d.isValid() ? d : null;
}

export type TaxBandApiDto = {
  id?: number;
  name?: string;
  taxCode?: string;
  taxRatePercent?: number;
  isActive?: boolean;
  include?: unknown[];
  exclude?: unknown[];
};

export type TaxRuleApiDto = {
  id?: number;
  name?: string;
  countryIsoCode?: string | null;
  countryId?: number | string;
  centreId?: number;
  centreName?: string | null;
  centre?: { id?: number; name?: string };
  startDate?: string | null;
  endDate?: string | null;
  isActive?: boolean;
  bands?: TaxBandApiDto[];
  lastModifiedBy?: string;
  lastModifiedBySurname?: string;
  lastModifiedByGivenName?: string;
  centreNames?: string[];
  centres?: { id?: number; name?: string }[];
  countryName?: string;
};

export type TaxRuleListRow = {
  id: number;
  name: string;
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  isActive: boolean;
  countryId?: number | string;
  centreId?: number;
  lastModifiedBySurname?: string;
  lastModifiedByGivenName?: string;
  lastModifiedBy?: string;
  scopeLabelsFromApi?: string[];
};